import { themeColors, themeSizes } from '../../../../styles/globalStyleVars';
import { IconX } from '@tabler/icons-react';
import styled from 'styled-components';
import { TypographyStyled } from '../../../Styled/Typography';
import { IconButton } from '@cfa/react-core';

const DrawerHeaderWrapper = styled.div`
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${themeColors.secondaryBlue};
  box-shadow: 0px 2px 4px 0px rgba(91, 103, 112, 0.24);
  position: sticky;
  top: 0;

  > div {
    display: flex;
  }

  > button {
    padding: 0;
  }
`;

type DrawerHeaderProps = {
  headerName: string;
  handleClose: () => void;
};

export const DrawerHeader = ({
  handleClose,
  headerName,
}: DrawerHeaderProps) => (
  <DrawerHeaderWrapper>
    <div
      style={{
        width: '100%',
        justifyContent: 'center',
        padding: `${themeSizes.lg} 0 ${themeSizes.lg} ${themeSizes.xxl}`,
      }}
    >
      <TypographyStyled
        text={headerName}
        fontWeight='medium'
        color={themeColors.secondaryBlue}
      />
    </div>
    <IconButton
      aria-label='Drawer Close Button'
      onPress={handleClose}
      style={{ paddingRight: themeSizes.lg }}
      data-testid='shared-drawer-close-button'
    >
      <IconX color={themeColors.secondaryBlue} />
    </IconButton>
  </DrawerHeaderWrapper>
);
